import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import Pricecalculator from '../../Components/pricecalculator';
import BuyButton from '../../Components/BuyButton';
import ProductTierPriceContainer from './ProductTierPriceContainer';
import ShoppingListButton from '../ShoppingListButton';
import Triangle from '../Triangle';
import Circle from '../Circle';
import Square from '../Square';
import ProductChainIcon from './ProductChainIcon';
import StoreList from '../StoreList';
import Popup from '../Popup';
import { getClickCollectOrgs } from '../../Actions/GetClickCollectOrgs.action';
import { googleAnalytics } from '../../Services/googleAnalytics';
import { updatePreferredClickCollectAddress } from '../../Actions/PreferredClickCollectAddress.action';

const GridViewModelContainer = (props) => {
  const dispatch = useDispatch();
  const schemaEnabled = props.disableSchemaMarkup !== true;
  const [titles, setTitleValue] = useState(
    props.excludeparsing == false ? JSON.parse(props.heading) : props.heading
  );
  const [products, setProducts] = useState(
    props.excludeparsing == false ? JSON.parse(props.products) : props.products
  );

  const [isChassiSearch, setIsChassiSearch] = useState(
    props.isChassiSearch ? props.isChassiSearch : false
  );
  const useToggle = props.useToggle || false; 
  const showAllProductInList = props.showAllProductInList || false; 
  const [isOpenStoreList, setOpenStoreList] = useState(false);
  const isrecommendedprice = useSelector((state) => state.recommendedprice.isrecommendedprice);
  const stores = useSelector((state) => state.clickCollectOrgs);
  const [store, setStore] = useState(null)
  const [reRender, setReRender] = useState(true)
  const hideShoppingList = window.__litium.constants.hideShoppingList;
  const showBuyButtons = window.__litium.constants.showBuyButtons;
  const { hidePrices} = window.__litium.channelConfig;
  const [expandedSpecs, setExpandedSpecs] = useState({});
  const [showAll, setShowAll] = useState(showAllProductInList);
  const [isMobile, setIsMobile] = useState(false);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [showExpandButton, setShowExpandButton] = useState({});


  const descriptionRef = (id) => (el) => {
    if (el && showExpandButton[id] === undefined) {
      const isOverflowing = el.scrollHeight > 46;
      if (isOverflowing) {
        setShowExpandButton(prev => ({ ...prev, [id]: true }));
      }
    }
  };

  const toggleDescription = (id) => {
    setExpandedDescriptions(prev => ({ ...prev, [id]: !prev[id] }));
  };

  useEffect(() => {
    const mql = window.matchMedia('(max-width: 1024px)'); 
    const onChange = () => setIsMobile(mql.matches);
    
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  const initialItemsCount = isMobile ? 2 : 4;
  const displayedProducts = useToggle
    ? showAll
      ? products
      : products.slice(0, initialItemsCount)
    : products;

  const itemClass = useToggle
    ? "product-list__item columns small-12 small-plus medium-6 large-3"
    : "product-list__item columns small-12 small-plus medium-4 large-3";

  useEffect(() => {
    let preffStore = JSON.parse(window.localStorage.getItem("preferedaddress"));
    let clickStore = JSON.parse(window.localStorage.getItem("preferredclickcollectaddress"));
    
    if(store == null && preffStore && preffStore.productAssortment?.includes("active")&& reRender){

        let streetAddress = preffStore.streetName;
        streetAddress += preffStore.zipCode ? " " + preffStore.zipCode : "";
        streetAddress += preffStore.city ? " " + preffStore.city : "";

        let store = {
          organizationId: preffStore.organizationId,
          organizationName: preffStore.companyName,
          email: preffStore.email,
          homePage: preffStore.homePage,
          address: streetAddress,
          productAssortment: preffStore.productAssortment,
          shopName: preffStore.name,
          latitude: preffStore.latitude,
          longitude: preffStore.longitude
        }
        setStore(store)
        setReRender(false)
        //window.localStorage.removeItem('preferredclickcollectaddress');
        dispatch(updatePreferredClickCollectAddress(store));
      
    }
    else if(clickStore){
      setStore(clickStore);
    }

  },[isOpenStoreList])

  const renderProductSpec = (product) => {
  const isExpanded = expandedSpecs[product.Id] === true;

  // filtrera specs
  const specs =
    product.SpecificationForProductPage?.filter(
      (s) => !s.IsArticleNumber && s.Value
    ) || [];

  const visibleSpecs = isExpanded ? specs : specs.slice(0, 2);
  const visibleProducts = showAll ? products : products.slice(0, 4);

  const toggleSpecs = () => {
    setExpandedSpecs((prev) => ({
      ...prev,
      [product.Id]: !isExpanded,
    }));
  };

  return (
    <div className="product__specification specification-wrap">
      <table className="product-table defaulttable">
        <tbody>
          <tr className="product__specification--list">
            <td className="name">
              {translate('product.shortenedarticlenumber')}
            </td>
            <td className="value">
              {product.Id}
              {product.HasChildOrIsChild === true && (
                <ProductChainIcon product={product} />
              )}
            </td>
          </tr>
          {visibleSpecs.map((specification, sindex) => (
            <tr
              className="product__specification--list"
              key={'tr' + sindex}
            >
              <td className="name">
                {specification.Name}
                {specification.Description && (
                  <span className="product-tooltip">
                    ?{' '}
                    <span
                      data-tip={specification.Description}
                      className="product-tooltip--content"
                    />
                  </span>
                )}
              </td>
              <td className="value">{specification.Value}</td>
            </tr>
          ))}
          {specs.length > 2 && (
            <tr>
              <td colSpan="2">
                <button
                  className={`spec-toggle-btn ${isExpanded ? 'is-expanded' : ''}`}
                  onClick={toggleSpecs}
                >
                  {isExpanded
                    ? translate('common.showless')
                    : translate('common.showmore')}
                </button>
              </td>
            </tr>
          )}
          {/* {isChassiSearch == true && (
            <tr>
              <td>{translate('product.articlenumber')}</td>
              <td className="value">
                {product.Id}
                {product.HasChildOrIsChild === true && (
                  <ProductChainIcon product={product} />
                )}
              </td>
            </tr>
          )} */}
          {product.StockStatus && (
            <tr className="product__specification--list">
              <td className="name">{translate('common.stock')}</td>
              <td className="value">
                {product.StockStatus == 'triangle' && <Triangle />}
                {product.StockStatus == 'circle' && <Circle />}
                {product.StockStatus == 'square' && (
                  <Square quantity={product.QuantityInStock} />
                )}
              </td>
            </tr>
          )}
          {/* {!hidePrices && (
            <tr className="product__specification--actions">
              <td className="name">
                {translate(
                  isrecommendedprice
                    ? 'product.rekpris'
                    : 'product.netprice'
                )}
              </td>
              <td className="value price">
                <Pricecalculator
                  isauthorized={
                    props.authenticated?.toString()?.toLowerCase() === 'true'
                  }
                  netpricincludingvat={product.NetPriceIncludingVAT}
                  netpriceexcludingvat={product.NetPrice}
                  recommendedpriceexcludingvat={product.RecommendedPrice}
                  recommendedpriceincludingvat={
                    product.RecommendedPriceIncludingVAT
                  }
                  campaignpriceincludingvat={
                    product.CampaignPriceIncludingVAT
                  }
                  campaignprice={product.CampaignPrice}
                />
              </td>
            </tr>
          )} */}
        </tbody>
      </table>
    </div>
  );
};

  const renderProduct = (product, index) => {
    const dispatch = useDispatch();

    const handleOpenPopup = (productId) => {
      setOpenStoreList(true);
      dispatch(getClickCollectOrgs(productId))
    }

    const getStockIndicator = (stock) => {
      if (stock == 0) {
        return "dot--red";
      } else if (stock == 1) {
        return "triangle";
      } else {
        return "dot";
      }
    };

    return (
            <div key={'li' + index}
              itemScope={schemaEnabled ? true : undefined}
              itemType={schemaEnabled ? 'http://schema.org/Product' : undefined}
              className={
                product.IsExpired
                  ? 'product__wrapper product--expired'
                  : 'product__wrapper'
              }
            >
              <figure className="product__figure">
                {product.PLCBanner && (
                  <span
                    className="plc-status"
                    style={{ backgroundColor: product.PLCBanner.ColorCode }}
                  >
                    {product.PLCBanner.Text}
                  </span>
                )}
                <a href={product.Url} title={product.Name} tabIndex={-1}>
                  <div
                    className="product__figure--img"
                    dangerouslySetInnerHTML={{ __html: product.ImageUrl }}
                  ></div>
                </a>
                {product.GridLogoLabel && (
                  <div className="product__grid-logo-label">
                    <img
                      src={product.GridLogoLabel}
                      alt={product.GridLogoLabelText || ""}
                      title={product.GridLogoLabelText || ""}
                      width={product.GridLogoLabelWidth || undefined}
                      height={product.GridLogoLabelHeight || undefined}
                    />
                  </div>
                )}
              </figure>
              <article className="product__info">
                {schemaEnabled && (
                  <meta itemProp="description" content={product.Description} />
                )}
                <a
                  href={product.Url}
                  className="product__name--link"
                >
                  <h3 itemProp={schemaEnabled ? 'name' : undefined} className="product__name">
                    {product.Name}
                  </h3>
                </a>
                <div
                  className="product__price"
                  itemProp={schemaEnabled ? 'offers' : undefined}
                  itemScope={schemaEnabled ? true : undefined}
                  itemType={schemaEnabled ? 'http://schema.org/Offer' : undefined}
                >
                  {schemaEnabled && (
                    <Fragment>
                      {!props.isClickAndCollect && product.IsInStock ? (
                        <link
                          itemProp="availability"
                          href="http://schema.org/InStock"
                        />
                      ) : (
                        <link
                          itemProp="availability"
                          href="http://schema.org/OutOfStock"
                        />
                      )}
                      <link itemProp="url" href={product.Url} />
                    </Fragment>
                  )}
                </div>
                {props.hidedescription == false && (
                  <div className="product__description-container">
                    <div 
                      ref={descriptionRef(product.Id)}
                      className="product__description-grid"
                      style={{
                      WebkitLineClamp: expandedDescriptions[product.Id] ? "unset" : "2",
                      overflow: "hidden",
                      minHeight: "46px",
                      height: expandedDescriptions[product.Id] ? "auto" : "46px",
                    }}
                    >
                      {product.Description}
                    </div>
                    {showExpandButton[product.Id] && (
                      <button 
                        onClick={(e) => {
                          e.preventDefault();
                          toggleDescription(product.Id);
                        }}
                        className={`spec-toggle-btn ${expandedDescriptions[product.Id] ? 'is-expanded' : ''}`}
                      >
                        {expandedDescriptions[product.Id] 
                          ? translate('common.showless') 
                          : translate('common.showmore')}
                      </button>
                    )}
                  </div>
                )}
                {renderProductSpec(product)}
                {/* {!hidePrices && !product.IsExpired && product.Price &&
                  product.Price.TierPrices &&
                  product.Price.TierPrices.length > 1 && (
                    <div className="grid-tier-price">
                      <ProductTierPriceContainer
                        product={JSON.stringify(product)}
                      />
                    </div>
                  )} */}
                <div className="product__buy">
                  {!hidePrices && (
                    <tr className="product__specification--actions">
                      <td className="name">
                        {translate(
                          isrecommendedprice
                            ? 'product.rekpris'
                            : 'product.netprice'
                        )}
                      </td>
                      <td className="value price">
                       <Pricecalculator
                         isauthorized={
                           props.authenticated?.toString()?.toLowerCase() === 'true'
                         }
                         netpricincludingvat={product.NetPriceIncludingVAT}
                         netpriceexcludingvat={product.NetPrice}
                         recommendedpriceexcludingvat={product.RecommendedPrice}
                         recommendedpriceincludingvat={
                           product.RecommendedPriceIncludingVAT
                         }
                         campaignpriceincludingvat={
                            product.CampaignPriceIncludingVAT
                          }
                          campaignprice={product.CampaignPrice}
                        />
                     </td>
                   </tr>
                  )}
                  {product.IsExpired && (
                    <span className="product__buy-text">
                      {translate(
                        product.ReplacementStatus == 'Never'
                          ? 'replacementProductLabel'
                          : 'similiarProductLabel'
                      )}{' '}
                      <a href={product.AlternativeURL}>
                        {product.AlternativeId}
                      </a>
                    </span>
                  )}

                  {!product.IsExpired && (
                    <div>
                      <div className={`product__buy--area ${props.isClickAndCollect ? 'easyline__buy--area' : ''}`}>
                        {showBuyButtons && (
                          <BuyButton
                            articleNumber={product.Id}
                            minValue={product.Price_Multiple}
                            cssClass={
                              product.EnableBuyButton
                                ? 'button buy-button product__buy-button'
                                : 'button buy-button product__buy-button disabled'
                            }
                            label={translate('button.addtocart')}
                            quantityFieldId=""
                          >
                            <span>
                              <a className='button buy-button product__buy-button'>
                                {translate('button.addtocart')}
                              </a>
                            </span>
                          </BuyButton>
                        )}
                        {props.isClickAndCollect && (
                          <BuyButton
                            articleNumber={product.Id}
                            minValue={product.Price_Multiple}
                            cssClass={
                              product.EnableBuyButton
                                ? 'button buy-button product__buy-button easyline__button'
                                : 'button buy-button product__buy-button easyline_button disabled'
                            }
                            label={translate('button.addtocart')}
                            quantityFieldId=""
                          >
                            <span className='easyline__span'>
                              <a className='button buy-button product__buy-button easyline__buy-button'>
                                {translate('button.addtocart')}
                              </a>
                            </span>
                          </BuyButton>
                        )}

                        {!hideShoppingList && (
                          <div className="no-padding shoppinglist-button">
                            <ShoppingListButton
                              productId={product.Id}
                              isSmall={(props.isClickAndCollect || showBuyButtons)}
                              product={product}
                            ></ShoppingListButton>
                            <div className='shoppinglist-tooltip'>{translate('tooltip.addtowishlist')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                {!hidePrices && !product.IsExpired && product.Price &&
                  product.Price.TierPrices &&
                  product.Price.TierPrices.length > 1 && (
                    <div className="grid-tier-price">
                      <ProductTierPriceContainer
                        product={JSON.stringify(product)}
                      />
                    </div>
                )}
                {product.ShouldShowStockStatus && props.isClickAndCollect && (
                  product.IsInStock ? (
                    <div>
                      {store && store.organizationId ? (
                        <div
                          className="product__stock-info product__stock-info--store"
                          tabIndex={0}
                          onClick={() => handleOpenPopup(product.Id)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              handleOpenPopup(product.Id);
                            }
                          }}
                        >
                          <div className={getStockIndicator(store.stock)}></div>
                          <span className="product__stock-info--stock">
                            {store.stock > 0
                              ? `+${store.stock} ${translate('storelist.isinstock')}`
                              : `${store.stock} ${translate('storelist.isinstock')}`}
                          </span>
                          <span className="product__stock-info--store-name">
                            {store.shopName}
                          </span>
                        </div>
                      ) : (
                        <a
                          className="product__stock-info"
                          title={product.Name}
                          tabIndex={0}
                          onClick={() => {
                            googleAnalytics({ event: 'clickAndCollectOpenStoreSelect' });
                            handleOpenPopup(product.Id);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              googleAnalytics({ event: 'clickAndCollectOpenStoreSelect' });
                              handleOpenPopup(product.Id);
                            }
                          }}
                        >
                          <span className='dot--not-selected'></span>
                          <span className="product__stock-info--textcolor">
                            {translate('product.showstores')}
                          </span>
                        </a>
                        )}
                      </div>
                  ) : (
                    <span className="product__stock-info">
                      {translate('product.isnotinstock')}
                    </span>
                  )
                )}
        </div>
      </article>
    </div>);
  };
  return (
    <Fragment>
      <div className="product-wrap--outer storeList-outer">
        <Popup
          isOpen={isOpenStoreList}
          setOpen={setOpenStoreList}
          component={
            <StoreList
              store={store}
              setStore={setStore}
              stores={stores.organizations}
              closeModal={() => setOpenStoreList(false)}
            />
          }
        />
        <div>
          <ul className="product-lists">
            {displayedProducts.map((product, index) => (
              <li
                className={itemClass}
                key={'grv-chassi-frg-main' + index}
              >
                {renderProduct(product, index)}
              </li>
            ))}
          </ul>
          {!showAllProductInList && useToggle && products && products.length > initialItemsCount && (
            <button
              className={`product-show-more ${showAll ? 'is-expanded' : ''}`}
              onClick={() => setShowAll(!showAll)}
            >
              {showAll
                ? translate('common.showless')
                : translate('common.showmore')}
            </button>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default GridViewModelContainer;
